import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  message,
  Radio,
  Select,
  Alert,
  Popconfirm,
  notification,
  Typography,
  Divider,
  Spin,
  Empty,
  Space,
} from "antd";
import Axios from "axios";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  useNavigate,
  useParams,
} from "react-router-dom";
import {
  HomeTwoTone,
  SettingTwoTone,
  SmileOutlined,
  SyncOutlined,
  LoadingOutlined,
  ArrowLeftOutlined,
  SmileTwoTone,
  BellOutlined,
  SettingOutlined,
  PhoneOutlined,
  UserOutlined,
  DeleteOutlined,
  DeleteTwoTone,
} from "@ant-design/icons";
import {
  environmentVariable,
  environment,
  apiRoutes,
} from "../../auth/apiRoute";
import AddStaff from "./addStaff";

export default function HotelProfile(props) {
  const { Title, Paragraph, Text } = Typography;
  const navigate = useNavigate();

  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [hotel, setHotel] = useState();
  const [currentNomination, setCurrentNomination] = useState({});
  let { hotelId } = useParams();

  const [hotels, setHotels] = useState([]);

  useEffect(() => {
    getHotelById(hotelId);
  }, []);

  const getHotelById = async (hotelId) => {
    setLoading(true);
    try {
      const response = await Axios.post(apiRoutes[environment].getHotel, {
        hotelId: hotelId,
      });

      if (response.status == 200) {
        setHotel(response.data);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }

    setLoading(false);
  };
  const deleteStaff = async (member) => {
    member.hotelId = hotelId;
    setLoading(true);
    try {
      const response = await Axios.post(
        apiRoutes[environment].removeStaff,
        member
      );

      if (response.status == 200) {
        getHotelById(hotelId);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }

    setLoading(false);
  };
  const openNotification = (message) => {
    notification.success({
      message: `Success!`,
      description: "Your nomination has been successfully updated! ",
      placement: "top",
    });
  };
  const reloadUser = () => {
    getHotelById(hotelId);
  };
  const showStaff = () => {
    if (hotel && hotel.staff) {
      return hotel.staff.map((member) => {
        return (
          <Paragraph key={member._id}>
            <Space size={65}>
              <span>
                {" "}
                <UserOutlined /> {member.firstName + " " + member.lastName}{" "}
              </span>
              {hotel && hotel.admin && hotel.admin._id == props.user.id ? (
                <Popconfirm
                  title="Are you sure to delete this member?"
                  onConfirm={() => deleteStaff(member)}
                  onCancel={() => {}}
                  okText="Confirm"
                  cancelText="No"
                >
                  <DeleteTwoTone />
                </Popconfirm>
              ) : (
                ""
              )}
              ,
            </Space>
          </Paragraph>
        );
      });
    }
  };

  return (
    <Spin spinning={hotel && loading}>
      <div>
        <>
          <Button onClick={() => navigate(-1)}>
            <ArrowLeftOutlined />
            go back
          </Button>
        </>
        <Title level={2}>{hotel && hotel.name ? hotel.name : ""}</Title>
        <Paragraph>
          <Paragraph>
            <BellOutlined /> {hotel && hotel.street ? hotel.street : ""},{" "}
            {hotel && hotel.city ? hotel.city : ""},{" "}
            {hotel && hotel.state ? hotel.state : ""},{" "}
            {hotel && hotel.zip ? hotel.zip : ""}
          </Paragraph>
          <Paragraph>
            <PhoneOutlined /> {hotel && hotel.phone ? hotel.phone : ""}
          </Paragraph>
          <Paragraph>
            <SettingOutlined /> {hotel && hotel.type ? hotel.type : ""}
          </Paragraph>
        </Paragraph>
        <Divider></Divider>
        <Title level={4}>Staff and Admin</Title>
        <Paragraph>
          Admin:{" "}
          {hotel && hotel.admin
            ? hotel.admin.firstName + " " + hotel.admin.lastName
            : ""}
        </Paragraph>
        {showStaff()}

        {hotel && hotel.admin && hotel.admin._id == props.user.id ? (
          <AddStaff reloadUser={reloadUser} />
        ) : (
          ""
        )}
      </div>
    </Spin>
  );
}
